
import { a11yProps, EstadoFactibilidadCorporativaENUM, sizeTab, useCheckPermissions } from "@/shared";
// import { useFetchContratos } from "@/shared/actions/erp";

import { Box, Tab, Tabs } from "@mui/material";
import { PermissionsEnum } from "@/auth/interfaces";
import { ClientesCoorporativosTableMain } from "../tables";
import { SingleTableBoxScene } from "@/shared/components/ui";
import { useState } from "react";
import { CustomTabPanel } from "@/erp/sale";


export interface ClientesCoorporativosPageInterface {}

const ClientesCoorporativosPage: React.FC<ClientesCoorporativosPageInterface> = () => {
  useCheckPermissions(PermissionsEnum.api_change_factibilidadcoorporativa);
  const [valueTab, setValueTab] = useState(0);
  
  return (
    <SingleTableBoxScene
      title={"Contabilidad de Clientes Corporativos"}
      visibleReport={true}
    >
      <Box sx={{ bgcolor: 'background.paper', maxWidth: sizeTab, paddingBottom: 1 }} >
        <Tabs
          value={valueTab}
          onChange={(_event: React.SyntheticEvent, newValue: number) => {
            setValueTab(newValue);
          }}
          variant="scrollable"
          scrollButtons="auto"
          allowScrollButtonsMobile
          aria-label="scrollable force tabs preventa"
        >
          <Tab label={"Por Revisar"} {...a11yProps(0)} />
          <Tab label={"Realizados"} {...a11yProps(1)} />
          <Tab label={"Aprobados"} {...a11yProps(2)} />
        </Tabs>
      </Box>
      <CustomTabPanel value={valueTab} index={0}>
        <ClientesCoorporativosTableMain
          aceptado_factibilidad={true}
          revisado_contabilidad={false}
        />
      </CustomTabPanel>
      <CustomTabPanel value={valueTab} index={1}>
        <ClientesCoorporativosTableMain
          aceptado_factibilidad={true}
          revisado_contabilidad={true}
          canEditGlobal={true}
        />
      </CustomTabPanel>
      <CustomTabPanel value={valueTab} index={2}>
        <ClientesCoorporativosTableMain
          estado_factibilidad={EstadoFactibilidadCorporativaENUM.APROBADO}
          aceptado_factibilidad={true}
          revisado_contabilidad={true}
          canEditGlobal={false}
        />
      </CustomTabPanel>

    </SingleTableBoxScene>














    // <Box
    //   component="main"
    //   sx={{
    //     flexGrow: 1,
    //     py: 8,
    //   }}
    // >
    //   <Container maxWidth="xl">
    //     <Stack >
    //       {/* ========= title & create btn ========= */}
    //       <Stack direction="row" justifyContent="space-between" spacing={4}>
    //         <Stack spacing={1} pb={2}>
    //           <Typography variant="h4">Clientes Corporativos Contabilidad</Typography>
    //         </Stack>
    //       </Stack>
          
    //     </Stack>
    //   </Container>
    // </Box>
  );
};

export default ClientesCoorporativosPage;
